(function(){'use strict';
function protectVerticalScroll(root){
  (root||document).querySelectorAll('.ci-product-rail').forEach(function(rail){
    if(rail.dataset.ciVerticalGuard==='1')return;
    rail.dataset.ciVerticalGuard='1';
    var sx=0,sy=0,locked=null;
    rail.addEventListener('pointerdown',function(e){sx=e.clientX;sy=e.clientY;locked=null},{passive:true,capture:true});
    rail.addEventListener('pointermove',function(e){
      if(locked)return;
      var dx=e.clientX-sx,dy=e.clientY-sy;
      if(Math.max(Math.abs(dx),Math.abs(dy))<8)return;
      locked=Math.abs(dx)>Math.abs(dy)?'x':'y';
      if(locked==='y'){
        /* Let the browser/theme editor own vertical scrolling. The older inline rail handler must not run. */
        e.stopImmediatePropagation();
      }
    },{passive:true,capture:true});
  });
}
function init(){protectVerticalScroll(document)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
window.addEventListener('load',init,{passive:true});
new MutationObserver(function(){protectVerticalScroll(document)}).observe(document.documentElement,{childList:true,subtree:true});
})();
